import { ajax } from '@/utils/request';
const api = {
    // 获取材料信息列表
    getPaymentMaterialList(data:any){
        return ajax({
            method: 'get',
            url: `material-mgt/materials-list`,
            data
        })
    },

    // 获取品牌列表
    getPaymentBrandList(data:any){
        return ajax({
            method: 'get',
            url: `brand-mgt/select-brand-list`,
            data
        })
    },

    // 付款申请材料合同和劳务合同查询
    getConcatByMaterialOrDouble(projectId: any,contractType: any,supplierId?:any){
        return ajax({
            method: 'get',
            url: `payment-mgt/material-or-double-contract/${projectId}`,
            data:{
                contractType: contractType,
                supplierId: supplierId
            }
        })
    },
    // 付款申请专项分包合同查询
    getConcatBySpecially(projectId: any){
        return ajax({
            method: 'get',
            url: `payment-mgt/specially-contract/${projectId}`
        })
    },

    // 双包和材料付款累计已支付金额明细
    getDoubleOrMaterialPaymentDetail(data:any){
        return ajax({
            method: 'get',
            url: `payment-mgt/double-or-material-payment-paid-detail`,
            data
        })
    },

    // 专项分包付款累计已支付金额明细
    getSpeciallyPaymentDetail(data:any){
        return ajax({
            method: 'get',
            url: `payment-mgt/specially-payment-paid-detail`,
            data
        })
    },

    // 零星材料付款已支付金额明细
    getSporadicPaymentDetail(data:any){
        return ajax({
            method: 'get',
            url: `payment-mgt/sporadic-payment-paid-detail`,
            data
        })
    },
    
    // 获取审批节点信息
    getProcessNodeInfo(processDefinitionKey:any){
        return ajax({
            method: 'get',
            url: `process-definition-mgt/user-task/${processDefinitionKey}`,
        })
    },

    // 查询劳务任务单
    getLabourTaskSituation(data:any){
        return ajax({
            method: 'get',
            url: `labour-task/query-task`,
            data
        })
    },

    // 查询双包任务清单
    getDoubleTaskSituation(data:any){
        return ajax({
            method: 'get',
            url: `double-task/query-task`,
            data
        })
    },

    // 查询专项分包任务清单
    getSpeciallyTaskSituation(data:any){
        return ajax({
            method: 'get',
            url: `specially-task/query-task`,
            data
        })
    },

    // 新增付款申请
    addPayment(data:any){
        return ajax({
            method: 'post',
            url: `payment-mgt/payment`,
            data
        })
    },
    // 修改付款申请
    updatePayment(data:any){
        return ajax({
            method: 'put',
            url: `payment-mgt/payment/${data.id}`,
            data
        })
    },
    // 获取付款申请详情
    getPaymentDetail(id:any){
        return ajax({
            method: 'get',
            url: `payment-mgt/payment/${id}`,
        })
    },
    // 获取流程流转详情
    getProcessTaskCirculation(processInstanceId:any){
        return ajax({
            method: 'get',
            url: `process-task-mgt/${processInstanceId}/circulation`,
        })
    },
    // 获取当前审批任务
    getCurrentTaskInfo(processInstanceId:any){
        return ajax({
            method: 'get',
            url: `process-task-mgt/${processInstanceId}/run-tasks`,
        })
    },
    // 审核通过
    paymentProcessAccept(data:any){
        return ajax({
            method: 'post',
            url: `payment-mgt/complete`,
            data
        })
    },

    // 审核不通过
    paymentProcessReject(data:any){
        return ajax({
            method: 'put',
            url: `payment-mgt/reject`,
            data
        })
    },

    // 获取项目下的班组
    getLabourClassByProject(projectId: any){
        return ajax({
            method: 'get',
            url: `labour-class-member/query-project-class-list/${projectId}`,
        })
    },

    // 材料代买付款累计已支付金额明细
    getInsteadBuyPaymentPaidMent(data: any){
        return ajax({
            method: 'get',
            url: `payment-mgt/instead-buy-payment-paid-detail`,
            data
        })
    },

    // 根据项目查询劳务合同
    getLabourContractByProject(projectId: any,data?:any){
        return ajax({
            method: 'get',
            url: `payment-mgt/labour-contract/${projectId}`,
            data:data
        })
    },

    // 劳务付款累计已支付金额明细
    getLabourPaymentPaidDetail(data: any){
        return ajax({
            method: 'get',
            url: `payment-mgt/labour-payment-paid-detail`,
            data
        })
    },

    // 劳务单包付款累计已支付金额明细
    getLabourSinglePaymentPaidDetail(data: any){
        return ajax({
            method: 'get',
            url: `payment-mgt/labour-single-payment-paid-detail`,
            data
        })
    },

    // 劳务/双包累计已支付金额明细
    getLabourDoublePaymentPaidDetail(data: any){
        return ajax({
            method: 'get',
            url: `payment-mgt/labour-double-payment-paid-detail`,
            data
        })
    },
    
    // 材料代买付款申请单查询
    getMaterialInsteadList(data: any){
        return ajax({
            method: 'get',
            url: `payment-mgt/instead-payment-select-list`,
            data
        })
    },
    // 申请退回
    paymentProcessBack(id: any){
        return ajax({
            method: 'put',
            url: `payment-mgt/${id}/back`
        })
    },

    // 申请作废
    paymentProcessCancel(id: any){
        return ajax({
            method: 'put',
            url: `payment-mgt/${id}/cancel`
        })
    },

    // 综合部劳务付款确认导出
    exportGeneralLabourConfirm(data:any){
        return ajax({
            method: 'get',
            url: `payment-mgt/export-labour-confirm`,
            type: "blob",
            data
        });
    },

    // 财务部项目付款确认导出
    exportFnianceProjectConfim(data:any){
        return ajax({
            method: 'get',
            url: `payment-mgt/export-project-confirm`,
            type: "blob",
            data
        });
    },

    // 劳务付款导出
    exportLabourPayment(data:any) {
        return ajax({
            method: 'get',
            url: `payment-mgt/export-labour`,
            type: "blob",
            data
        });
    },

    // 双包付款导出
    exportDoubelPayment(data:any) {
        return ajax({
            method: 'get',
            url: `payment-mgt/export-double`,
            type: "blob",
            data
        });
    },

    // 材料付款导出
    exportMaterialPayment(data:any) {
        return ajax({
            method: 'get',
            url: `payment-mgt/export-material`,
            type: "blob",
            data
        });
    },

    // 付款申请统计
    paymentDataCount(data:any){
        return ajax({
            method: 'get',
            url: `payment-mgt/payment-sum`,
            data
        });
    },

    // 下载申请单
    downloadPayment(id:any){
        return ajax({
            method: 'get',
            type: "blob",
            url: `payment-mgt/export-pdf/${id}`,
        });
    },
    // 下载申请单原件
    downloadPaymentWord(id:any){
        return ajax({
            method: 'get',
            type: "blob",
            url: `payment-mgt/export-word/${id}`,
        });
    },
    // 材料付款班组下拉查询
    getPaymentMaterialClass(data:any){
        return ajax({
            method: 'get',
            url: `payment-mgt/material-class-list`,
            data
        });
    },
}

export default api;